export const environment = {
    msalConfig: {
        clientId: 'fb16027b-8271-48f3-91a6-3ec17d8e1216',
        authority: 'https://login.microsoftonline.com/cc74fc12-4142-400e-a653-f98bfa4b03ba',
        redirectUri: '/login/callback',
        postLogoutRedirectUri: '/',
    },
    serviceUrl: 'https://companystore-service.eex.ea.com'
};